import { Component, inject, model } from '@angular/core';
import { PermissionsService } from '../services/permissions.service';
import { ProfileService } from '../../profile/services/profile.service';
import { ActivatedRoute } from '@angular/router';
import { PermissionsModel } from '../../shared/models/permissions.model';
import { PermissionsFormComponent } from "../permissions-form/permissions-form.component";
import { CardModule } from 'primeng/card';
import { AccessService } from '../../core/services/access.service';

@Component({
  selector: 'app-permissions-delete',
  standalone: true,
  imports: [PermissionsFormComponent, CardModule],
  templateUrl: './permissions-delete.component.html',
  styleUrl: './permissions-delete.component.css'
})
export class PermissionsDeleteComponent {
  private service = inject(PermissionsService)
  private route = inject(ActivatedRoute)

  protected access = inject(AccessService).access

  id!: string | null;

  value = model<PermissionsModel | undefined>(undefined)

  ngOnInit(): void {
    this.service.title.update((value) => 'Permiso Eliminado')
    this.route.paramMap.subscribe(params => {
      this.id = params.get('id');
      this.getValue(params.get('id'));
    });
  }

  getValue(id: string | null) {
    if (id === null) {
      this.value.update((value) => (value = undefined));
    } else {
      this.service.delete(id).subscribe((data) => {
        this.value.update(value => {
          value = data as PermissionsModel
          // console.log('permissions: ', value);
          return value;
        });
      });
    }
  }
}
